/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseRegionGeoModalFragment} from '@amblique/contentful/app/contentful/fragments/region-geo-modal/base-region-geo-modal.fragment';

export const FullRegionGeoModalFragment = gql`
  ${BaseRegionGeoModalFragment}

  fragment FullRegionGeoModalFragment on RegionGeoModal {
    ...BaseRegionGeoModalFragment
  }
`;
